import { EVENT_CATEGORIES, INTERNAL_CATEGORY, eventCategoryOf } from 'constants/eventCategories';
import joinDetails from 'helper/joinDetails';
import { clockLabel, durationLabel } from 'helper/timeLabels';
import useHomeText from 'hooks/useHomeText';

/**
 * An appointment of the day, as the planning lists it: its time and length,
 * the bar and tag of its category, the company (an internal meeting shows its
 * own title) and who and where. A done appointment fades. A Google event opens
 * in Google Calendar; the others call `onOpen`.
 */
const AppointmentItem = ({ appointment, onOpen }) => {
  const { categoryLabel } = useHomeText();
  const category = eventCategoryOf(appointment.category);
  const colours = EVENT_CATEGORIES[category];
  const start = new Date(appointment.startsAt);
  const minutes = Math.round((new Date(appointment.endsAt) - start) / 60000);
  const internal = category === INTERNAL_CATEGORY;
  const title = internal ? appointment.title : appointment.company?.name || appointment.title;
  const details = internal
    ? appointment.description
    : joinDetails([
        appointment.contactName || appointment.company?.contactName,
        category !== 'prospection' && category !== 'visite_client' && appointment.description
          ? appointment.description
          : appointment.location,
      ]);
  const open = () =>
    appointment.externalLink
      ? window.open(appointment.externalLink, '_blank', 'noopener')
      : onOpen(appointment);
  return (
    <button
      type="button"
      onClick={open}
      className={`-mx-2 flex shrink-0 gap-3 rounded-lg px-2 py-2.5 text-left transition-colors hover:bg-gray-50 ${
        appointment.status === 'done' ? 'opacity-60' : ''
      }`}
    >
      <span className="flex w-11 shrink-0 flex-col">
        <span className="text-sm font-semibold leading-5 text-gray-900">{clockLabel(start)}</span>
        <span className="text-xs leading-4 text-gray-600">{durationLabel(minutes)}</span>
      </span>
      <span className={`w-[3px] shrink-0 self-stretch rounded-sm ${colours.bar}`} />
      <span className="flex min-w-0 flex-1 flex-col items-start gap-1">
        <span className={`rounded px-2 py-0.5 text-xs font-medium ${colours.tag}`}>
          {categoryLabel(category)}
        </span>
        <span className="text-sm font-medium leading-5 text-gray-900">{title}</span>
        {details && <span className="text-xs leading-4 text-gray-600">{details}</span>}
      </span>
    </button>
  );
};

export default AppointmentItem;
